import { Tc, PagingResultsViewModel } from "../../../core/_infrastructure/types/common";


export class ErrorTracesItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: ErrorTracesViewModel[];
}
export class ErrorTracesViewModel {

    constructor() {

    }

    public Id: number;
    public ErrorTraces: string = '';
    public DescripcionError: string = '';
    public MensajeError: string = '';
}







